import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';

import {SignupMode} from './signup-mode.enum';

/**
 * Resolves the {@link SignupMode} for the current signup route. Declarative — reads route data
 * only; no inline `if ecommerce` conditionals belong anywhere downstream.
 */
@Injectable({providedIn: 'root'})
export class SignupModeService
{
    /**
     * Returns the mode declared on the route's data (`{mode: SignupMode.TRIMMED}` on the
     * trimmed-flow route). Defaults to {@link SignupMode.FULL} when no mode is declared.
     */
    public resolveFromRoute(route: ActivatedRouteSnapshot): SignupMode
    {
        const declared: string | undefined = route?.data?.['mode'];
        return declared === SignupMode.TRIMMED ? SignupMode.TRIMMED : SignupMode.FULL;
    }
}
